import { DEFAULT_LANG, LangToFormsLangMap } from 'forms-utils-lib/language/LanguageConstants';
export const getDefaultLangAsFormLang = () => LangToFormsLangMap[DEFAULT_LANG];